// removed by extract-text-webpack-plugin
module.exports = {"postContainer":"src-pages----post-module---postContainer---3N89j","section":"src-pages----post-module---section---2UP7x","post":"src-pages----post-module---post---20KrA"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/post.module.less
// module id = 85
// module chunks = 10495410396556 212839066777427